import type { CreditTopupEntrypoint } from '@/Domain/api/Subscription/dto/CreditTopup.dto';

export const CREDIT_TOPUP_SOURCE_QUERY_PARAM = 'topup_source';
export const CREDIT_TOPUP_RETURN_STATUS_QUERY_PARAM = 'topup';
export const CREDIT_TOPUP_ENTRYPOINT_BILLING = 'billing_page';
export const CREDIT_TOPUP_ENTRYPOINT_DISCORD_LIMIT = 'discord_credit_limit';
export const CREDIT_TOPUP_CHECKOUT_ATTRIBUTION_KEY = '__qc_credit_topup_checkout_attribution';

export type CreditTopupCheckoutAttribution = {
  flow: 'purchase' | 'card_setup';
  entrypoint: CreditTopupEntrypoint;
  auto_reload: boolean;
  has_balance: boolean;
};

export const getCreditTopupEntrypoint = (searchParams: URLSearchParams): CreditTopupEntrypoint =>
  searchParams.get(CREDIT_TOPUP_SOURCE_QUERY_PARAM) === CREDIT_TOPUP_ENTRYPOINT_DISCORD_LIMIT
    ? CREDIT_TOPUP_ENTRYPOINT_DISCORD_LIMIT
    : CREDIT_TOPUP_ENTRYPOINT_BILLING;

export const saveCreditTopupCheckoutAttribution = (
  attribution: CreditTopupCheckoutAttribution,
): void => {
  try {
    sessionStorage.setItem(CREDIT_TOPUP_CHECKOUT_ATTRIBUTION_KEY, JSON.stringify(attribution));
  } catch {
    return;
  }
};

export const readCreditTopupCheckoutAttribution = (): CreditTopupCheckoutAttribution | null => {
  try {
    const raw = sessionStorage.getItem(CREDIT_TOPUP_CHECKOUT_ATTRIBUTION_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<CreditTopupCheckoutAttribution>;
    if (
      (parsed.flow !== 'purchase' && parsed.flow !== 'card_setup') ||
      (parsed.entrypoint !== CREDIT_TOPUP_ENTRYPOINT_BILLING &&
        parsed.entrypoint !== CREDIT_TOPUP_ENTRYPOINT_DISCORD_LIMIT) ||
      typeof parsed.auto_reload !== 'boolean' ||
      typeof parsed.has_balance !== 'boolean'
    ) {
      return null;
    }
    return parsed as CreditTopupCheckoutAttribution;
  } catch {
    return null;
  }
};

export const clearCreditTopupCheckoutAttribution = (): void => {
  try {
    sessionStorage.removeItem(CREDIT_TOPUP_CHECKOUT_ATTRIBUTION_KEY);
  } catch {
    return;
  }
};
